// extracted by mini-css-extract-plugin
export default {"noBorders":"HeatingCircut_noBorders__zjA5S","standAlone":"HeatingCircut_standAlone__XeT9r","alwaysEnabled":"HeatingCircut_alwaysEnabled__0Jh79"};